<template>
  <div class="w1200 newsBox">
    <div class="leftBox">
      <div class="bannerBox">
        <Banner />
      </div>
      <div>
        <Firstcolumn v-if="newsIinitData.contentTypes" :columnlist="columnlist" :alldata="newsIinitData" />
      </div>
    </div>
    <div class="rightBox">
      <Rightlist />
    </div>
  </div>
</template>
<script>
import Banner from '@/components/banner_smoll'
import Firstcolumn from '@/views/firstlist/firstcolumn_library'
import Rightlist from '@/components/commonRightList'
export default {
  components: { Banner, Firstcolumn, Rightlist },
  head() {
    // var listObj = this.$store.state.hotList_home
    var metaStr = ''
    // listObj.forEach(a => {
    //   metaStr += a.CONTENT_TITLE + ' | '
    // })
    return {
      title: '资料文库-彭祖世家网Pengzushijia.com',
      mateDesc: '《彭祖世家总谱-事典》门户网站Pengzushijia.COM ，系彭祖世家文化发展有限公司与武汉聚脉网络科技有限公司合作,专属服务全球彭氏族群编纂《彭祖世家总谱-事典》总谱、家族谱、家庭谱的互联网家谱协作编纂平台。',
      keys: '彭祖,彭城,彭氏,彭姓,彭氏家谱,彭氏宗谱,彭氏族谱,彭祖世家,彭氏修谱,门户网站'
    }
  },
  computed: {
    columnlist() {
      var arrs = this.$store.state.libraryData.contentTypes
      if (arrs) {
        if (arrs[0].value !== '') {
          arrs.unshift({ 'value': '', 'name': '全部' })
        }
      }
      return arrs
    },
    newsIinitData() {
      return this.$store.state.libraryData
    }
  },
  asyncData({ store, route }) {
    return store.dispatch('getlibraryInitData', { templateId: route.params.templateId })
  },
  mounted() {
    window.addEventListener('beforeunload', this.fn)
  },
  destroyed() {
    window.removeEventListener('beforeunload', this.fn)
  },
  methods: {
    fn: function() {
      window.scrollTo(0, 0)
    }
  }
}
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
  .newsBox{
    background-color: #fafafa;
    overflow: hidden;
    position: relative;
  }
  .leftBox{
    width: 880px;
    margin-right: 20px;
    margin-top: 20px;
    float: left;
    .bannerBox{
      width: 880px;
      height: 340px;
    }

  }
  .rightBox{
    width: 300px;
    /*margin-left: 20px;*/
    margin-top: 20px;
    float: right;
    /*top: 0;*/
    /*right: 0;*/
    overflow: hidden;
  }
</style>

<!--手机端样式-->
<style rel="stylesheet/scss" lang="scss" scoped>
  @media screen and (max-width: 750px) {
    .leftBox{
      width: 100%;
      margin-top: 0;
      .bannerBox{
        width: 100%;
        height: auto;
      }
    }
    .rightBox{
      display: none;
    }
  }
</style>
